/**
 * Task rows of one pay segment. Renders NOTHING when `taskRow` says there is nothing to show: a run
 * issued before task pay was itemised never recorded the fields, and an absence must not print as
 * a confident zero. Place it inside a `<dl>`.
 */
import { useTranslation } from 'react-i18next'

import { taskRow, type TaskRowInput } from '../../lib/payroll'

export function TaskPayLines({
  segment,
  money,
}: {
  segment: TaskRowInput
  money: (value: number) => string
}) {
  const { t } = useTranslation()
  const row = taskRow(segment)
  if (row === null) return null
  const unit = row.unitLabel ?? t('payroll.taskRules.segUnitDefault')
  return (
    <>
      <div className="flex justify-between gap-3">
        <dt className="text-slate-500 dark:text-slate-400">
          {t('payroll.taskRules.segPay')}
          {row.setName ? ` · ${row.setName}` : ''}
        </dt>
        <dd className="tabular-nums text-slate-700 dark:text-slate-200">
          {row.count} {unit} · {money(row.pay)}
        </dd>
      </div>
      {row.days.map((day) => (
        <div key={day.day} className="flex justify-between gap-3 pl-2">
          <dt className="tabular-nums text-slate-500 dark:text-slate-400">{day.day}</dt>
          <dd className="tabular-nums text-slate-700 dark:text-slate-200">
            {day.count} × {money(day.rate)} = {money(day.pay)}
          </dd>
        </div>
      ))}
    </>
  )
}
